import React from 'react';
import PropTypes from 'prop-types';
import {FormattedNumber} from "react-intl";

class FormaterCurrency extends React.Component {

    otherProps = {};

    constructor(props) {
        super(props);

        let {value, ...otherProps} = this.props;
        this.otherProps = otherProps;

        this.state = {value};
    }

    render() {
        let {unit, currency, ...other} = this.otherProps;
        return (
            <FormattedNumber
                style="currency"
                value={this.state.value}
                currency={unit || currency || "EUR"}
                {...other}
            />
        )
            ;
    }
}

FormaterCurrency.propTypes = {
    /*value: PropTypes.string*/
    value: PropTypes.number
};

export default FormaterCurrency;
